// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.import-text[data-v-8d10f3f2] {
  text-align: left;
  color: #5F6B71;
}
.import-text[data-v-8d10f3f2] > * + * {
  margin-top: 8px;
}
.role-list[data-v-8d10f3f2] {
  background-color: #F2F2F2;
  margin: 8px 0 0 0;
  padding: 8px;
  list-style: none;
  font-weight: 500;
  max-height: 200px;
  overflow-y: auto;
}
.role-list li[data-v-8d10f3f2] {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/vue/RequiredStaffImportText.vue"],"names":[],"mappings":";AA4CA;EACE,gBAAgB;EAChB,cAAc;AAChB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AAEA;EACE,SAAS;AACX","sourcesContent":["<script setup lang=\"ts\">\nimport { RawRole } from \"../api/rawRole\";\n\nconst props = withDefaults(\n  defineProps<{\n    roles?: RawRole[];\n    userId: string;\n    branchId: string;\n  }>(),\n  {\n    roles: () => [],\n  },\n);\n\nfunction exportCsv() {\n  window.open(\n    `/dashboard/${props.userId}/roles/role_staff_requirement_bulk_export?c=${props.branchId}`,\n  );\n}\n</script>\n\n<template>\n  <div class=\"import-text\">\n    <div>\n      CSVファイルから業務ごとの日別必要人数を一括登録できます。\n    </div>\n    <div>\n      下記の業務コードを使用して業務を選択してください。\n    </div>\n    <ul class=\"role-list\">\n      <li v-for=\"role in props.roles\" :key=\"role.ID\">\n        {{ role.Name }} - {{ role.ID }}\n      </li>\n    </ul>\n    <div>\n      または\n    </div>\n    <button class=\"oplus-btn oplus-create-btn font-sm\" @click=\"exportCsv\">\n      既存の業務コードと必要人数の一覧をダウンロードする\n    </button>\n  </div>\n</template>\n\n<style scoped>\n.import-text {\n  text-align: left;\n  color: #5F6B71;\n}\n\n.import-text > * + * {\n  margin-top: 8px;\n}\n\n.role-list {\n  background-color: #F2F2F2;\n  margin: 8px 0 0 0;\n  padding: 8px;\n  list-style: none;\n  font-weight: 500;\n  max-height: 200px;\n  overflow-y: auto;\n}\n      \n.role-list li {\n  margin: 0;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
